import request from "@/utils/request";

export function postTrackInfoApi(data) {
  return request({
    url: `/distribution/system/eventTracking`,
    method: "post",
    data,
  });
}

//获取官网视频信息
export function getWebsiteConfigApi(params) {
  return request({
    url: `/distribution/system/websiteVideo/getStartVideo`,
    method: "get",
    params
  });
}

//获取更新信息
export function getUpdateApi(type, platform) {
  return request({
    url: `/system/app/manage/last?type=${type}&platform=${platform}`,
    method: "get",
  });
}
//埋点
export function postTrackInfo(data) {
  return request({
    url: `/distribution/system/eventTracking`,
    method: "post",
    data: {
      ...data,
      current: 'OfficialWebsite'
    }
  });
}
//埋点
export function newPostTrackInfo(data) {
  return request({
    url: `/distribution/system/eventTracking`,
    method: "post",
    data: {
      ...data,
    }
  });
}

//填手机号了
export function postPhone(data) {
  return request({
    url: `/distribution/system/leads/post_leads`,
    method: "post",
    data
  });
}

export function codePasApi(data) {
  // 获取验证码
  const { phone } = data;
  // console.log(phone);
  return request({
    url: `/distribution/api/sms/public/app/code/website/${phone}`,
    method: "post",
    data,
    headers: {
      jumpAuth: true,
    },
  });
}

export function checkCodePasApi(data) {
  // console.log(phone);
  return request({
    url: `/distribution/api/sms/public/check/code`,
    method: "post",
    data,
    headers: {
      jumpAuth: true,
    },
  });
}